<div class="pt-3 mb-1 row justify-content-between align-items-center">
    @if (showBackButton) {
        <div class="col-3 text-left">
            <div style="max-width: 50px" class="w-100 text-left align-self-center">
                <i (click)="goBack()" style="font-size: 2em" class="las la-angle-left la-3x mca-action rounded"></i>
            </div>
        </div>
    }
    <div (click)="goHome()" [ngClass]="{ 'col-6 text-center': showBackButton, 'col-auto': !showBackButton }">
        <ng-container #logoContainer></ng-container>
    </div>
    <div class="align-self-center d-flex align-items-center col-3 justify-content-end">
        <div [routerLink]="config.route" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="text-brand">
            <i class="{{ config.icon }} la-2x mca-action rounded"></i>
        </div>
        @if (isLanguageSwitcherEnabled()) {
            <shared-language-switcher [stylingClass]="'border-0 ms-2'" />
        }
    </div>
</div>
